require('./aggregatorCredentialsPSD2Styles.scss')

// @ vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @ components
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { LoadingSection } from 'commonsComponents/loadingSection';

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
import Storage from 'utilities/storage';

// @ actions
import { requestToken } from 'actions/aggregator/aggregatorAddEntityPSD2';
import { initStorePSD2 } from 'actions/aggregator/aggregatorAddEntityPSD2';

// @constants
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';

class AggregatorPSD2Token extends Component {

    constructor() {
        super();
        const { bankName, bankLogo, bankCode, state, code } = Storage.localStorage.get(SELECTED_BANK) || {};
        this.state = { bankName, bankLogo, bankCode, state, code }
    }

    componentDidMount() {
        const { requestToken } = this.props;
        const { bankCode, state, code } = this.state;

        requestToken(bankCode, state, code);
    }

    componentDidUpdate(prevProps) {
        const { isFetching, response, continueFlowCallback } = this.props;
        const selectedBankStorage = Storage.localStorage ? Storage.localStorage.get(SELECTED_BANK) : {};

        if (prevProps.isFetching !== isFetching && !isFetching) {
            const areCredentialsOk = response && response.get('userBankId');
            const newSelectedBank = areCredentialsOk && { ...selectedBankStorage, userBankId: response.get('userBankId')};
            Storage.localStorage.set(SELECTED_BANK, newSelectedBank);
            continueFlowCallback(areCredentialsOk);
        }
    }

    componentWillUnmount() {
        const { initStorePSD2 } = this.props;
        initStorePSD2();
    }

    render() {
        const { bankLogo, bankName } = this.state;
        const { isFetching } = this.props;

        return (
            <OKSectionBox className="aggregator-psd2-credentials col-md-8" title={formatText('aggregatorPSD2-credentialsTokenTitle', [bankName])} >
                <div className="aggregator-psd2-credentials__information">
                    <FormattedText value="aggregatorPSD2-credentialsTokenInformation" />
                </div>
                <div className="aggregator-psd2-credentials__logo-bank-wrapper">
                    <img className="aggregator-psd2-credentials__logo-bank" src={bankLogo} />
                </div>
                {isFetching && <LoadingSection />}
            </OKSectionBox>
        )
    }
}

AggregatorPSD2Token.propTypes = {
    isFetching: PropTypes.bool,
    response: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    requestToken: PropTypes.func.isRequired,
    initStorePSD2: PropTypes.func.isRequired,
    continueFlowCallback: PropTypes.func.isRequired,
}

export default connect(state => ({
    isFetching: state.aggregatorAddEntityPSD2.get('isFetchingToken'),
    response: state.aggregatorAddEntityPSD2.get('responseToken'),
}), {
    initStorePSD2,
    requestToken,
})(AggregatorPSD2Token)
